// components
import { CommandPaletteEmptyState } from 'src/components/command-palette';
import VoterLookupTag from './VoterLookupTag';
import { Button, Stack, Typography } from '@mui/material';

import { VoterSearchForm } from 'src/@types/voterSearch';
import { useOrg } from 'src/hooks/query/orgHooks';
import { ChevronLeft } from '@mui/icons-material';

type VoterLookupLoadingScreenProps = {
  search: VoterSearchForm;
  onBack?: () => void;
};

function VoterLookupLoadingScreen({ search, onBack }: VoterLookupLoadingScreenProps) {
  const { data: org } = useOrg();

  return (
    <Stack gap={2}>
      <Stack gap={1} flexDirection="row" alignItems="start" justifyContent="space-between">
        <Button variant="text" color="inherit" onClick={onBack} startIcon={<ChevronLeft />}>
          Back
        </Button>
      </Stack>
      <CommandPaletteEmptyState
        loading
        title="Searching for Voters"
        content={
          <Stack gap={1} flexDirection="column" alignItems="center">
            <Typography variant="body2" color="textSecondary">
              Searching for voters based on the criteria below.
            </Typography>
            <Stack
              direction="row"
              gap={1}
              mt={1}
              flexWrap="wrap"
              alignItems="center"
              justifyContent="center"
            >
              {Object.entries(search).map(([key, value]) => {
                if (value) {
                  return <VoterLookupTag key={key} label={key} value={value} org={org} />;
                }
              })}
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
}

export default VoterLookupLoadingScreen;
